import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { commafy } from 'helpers/number';
import { Button } from 'components/form/Button/Button';
import { Image } from 'components/Image/Image';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import './AutoLoanModuleRedesign.scss';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { AUTO_LOAN_VERTICAL } from 'types/mrph.vertical.constants';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import SeeAll from 'components/SeeAllButton/index';
import { Link } from 'components/navigation/Link/Link';

const AutoLoanTemplate = props => {
  const { offerMetadata, clickDetailsHandler, seenPixel } = props;
  const toAutoLoanPage = () => {
    props.eventHandler(CLICK, {
      'Click Type': 'To Auto Loan MarketPlace',
    });
    props.history.push('/offers?vertical=AUTO_LOAN');
  };
  return (
    <>
      {seenPixel}
      <FlexContainer
        className={
          'flex-container system_neutral_n000 grayShadow16 margt12 border-rad8px padT40 padB40 m-padT20 m-padT36'
        }
      >
        <Row className={'format100'}>
          <FlexContainer className={'m-flex-row'}>
            <FlexContainer className={'justify-between format100'}>
              <FlexContainer className={'align-self-center m-hide margt10'}>
                <Image className={'autoLoanIcon'} />
              </FlexContainer>
              <FlexContainer className={'flex-column format50 m-format100'}>
                <Label className="text-18 m-text-16 bold system_neutral_n400_text">
                  {'Thinking about getting a new car?'}
                </Label>
                <FlexContainer className={'margt10'}>
                  <FlexContainer
                    className={'flex-column padr12 featureRightBorder'}
                  >
                    <Label
                      type="Body-2"
                      className={
                        'text-16 m-text18 bold system_neutral_n400_text'
                      }
                    >
                      ${commafy(offerMetadata?.monthlyPayment)}/mo.
                    </Label>
                    <Label
                      type="Body-2"
                      className={
                        'text-12 margtb5 bold system_neutral_n400_text'
                      }
                    >
                      Estimated payment
                    </Label>
                  </FlexContainer>
                  <FlexContainer className={'flex-column padl12'}>
                    <Label
                      type="Body-2"
                      className={
                        'text-16 m-text18 bold system_neutral_n400_text'
                      }
                    >
                      ${commafy(offerMetadata?.loanAmount)}
                    </Label>
                    <Label
                      type="Body-2"
                      className={
                        'text-12 margtb5 bold system_neutral_n400_text'
                      }
                    >
                      Total car cost
                    </Label>
                  </FlexContainer>
                </FlexContainer>
                <Link
                  type="Body-2"
                  className={
                    'text-14 m-text-12 margt10 secondary_text_light pointer'
                  }
                  onClickCallback={toAutoLoanPage}
                  ariaLabel="See All Options"
                >
                  See All Options
                </Link>
              </FlexContainer>
              <FlexContainer
                className={'align-self-center margt10 m-margt20 m-hide'}
              >
                <Button
                  mrphType="primary"
                  onClick={clickDetailsHandler}
                  className="border-rad100px"
                >
                  <Label
                    type="Subtitle-2"
                    color="primary_cta_text_light"
                    className={'text-16 m-text-14 padlr40'}
                    tabIndex="-1"
                  >
                    {'View Offer'}
                  </Label>
                </Button>
              </FlexContainer>
            </FlexContainer>
            <FlexContainer
              className={
                'justify-between gap-16 m-flex-direction-column-reverse d-hide'
              }
            >
              <Image className={'autoLoanIcon'} />
              <FlexContainer className={'align-self-center'}>
                <Button
                  mrphType="primary"
                  onClick={clickDetailsHandler}
                  className="border-rad100px"
                >
                  <Label
                    type="Subtitle-2"
                    color="primary_cta_text_light"
                    className={'text-16 m-text-14'}
                  >
                    {'View Offer'}
                  </Label>
                </Button>
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>
        </Row>
      </FlexContainer>
    </>
  );
};

const AutoLoanModuleView = props => {
  const { offers } = props;
  const offer = offers[0];
  const trackingAtr = getViewModuleTrackingAttributes({
    pagePosition: 'Auto Loan Purchase',
    Vertical: AUTO_LOAN_VERTICAL,
    modulePosition: props.modulePosition,
  });
  const seenModuleTracking = useSeenModulePixel(trackingAtr);

  const toAutoLoanPage = () => {
    props.eventHandler(CLICK, {
      'Click Type': 'To Auto Loan offers',
    });
    props.history.push('/offers?vertical=AUTO_LOAN');
  };

  if (offer?.monthlyPayment > 0) {
    return (
      <FlexContainer className={'autoLoanModuleContainer flex-column'}>
        {seenModuleTracking}
        <FlexContainer className={'justify-between align-baseline'}>
          <Label
            type="H4"
            typeHeader={'h2'}
            className={'margB0 m-text-12 system_neutral_n500_text'}
          >
            Auto loans for your profile
          </Label>
          <SeeAll
            onClick={toAutoLoanPage}
            className={
              'm-margT6 text-12 m-text-12 align-baseline secondary_text_light'
            }
          />
        </FlexContainer>
        <StaticOfferContainer
          offerMetadataList={[offer]}
          autoLoanTemplate={AutoLoanTemplate}
          pagePosition={props.pagePosition}
          modulePosition={props.modulePosition}
          eventHandler={props.eventHandler}
        />
      </FlexContainer>
    );
  } else {
    return <></>;
  }
};

export default AutoLoanModuleView;
